import { Iata, PlatformConfig } from '@reward-platform/shared-schemas'
import { isAviosPlatform } from './platformType'

import { PlatformError } from '../errors'
import { isString } from '../typeChecks'
import { isProduction, isStaging } from '../envChecks'
import { DEFAULT_OP_CO, getOpCoMetaConfig, OP_CO_META_CONFIGS } from './platformConfig'

const parseWhitelist = (value: unknown) =>
  isString(value) ? value.split(',').map((domain) => domain.trim()) : []

const WHITELABEL_URL_WHITELISTS: Record<string, string[]> = {
  BA: parseWhitelist(process.env.NEXT_PUBLIC_BA_DOMAIN_WHITELIST),
  EI: parseWhitelist(process.env.NEXT_PUBLIC_EI_DOMAIN_WHITELIST),
  // IB: parseWhitelist(process.env.NEXT_PUBLIC_IB_DOMAIN_WHITELIST),
  VY: parseWhitelist(process.env.NEXT_PUBLIC_IB_DOMAIN_WHITELIST),
}

export const isAviosThemeWhitelisted = (host: string) => {
  const isLowerEnv = !isProduction() && !isStaging()
  const aviosThemeUrlWhitelist = parseWhitelist(process.env.NEXT_PUBLIC_AVIOS_DOMAIN_WHITELIST)
  return isLowerEnv && aviosThemeUrlWhitelist.includes(host)
}

// This determines the platform op co, validating the request using whitelisted urls
export const getWhitelabelOpCoForHost = (host?: string) => {
  // if avios.com build then return default with no errors
  if (isAviosPlatform()) {
    // value should not be used if not whitelabel platform
    return DEFAULT_OP_CO
  }

  if (!host) {
    throw new PlatformError(`No whitelabel OpCo found as host was undefined`)
  }

  const iataCodes = Object.keys(OP_CO_META_CONFIGS) as Array<Iata>
  const maybeIata = iataCodes.find((iata) => WHITELABEL_URL_WHITELISTS[iata].includes(host))
  if (maybeIata) {
    return maybeIata
  }
  // not throwing if theme is whitelisted for testing
  if (isAviosThemeWhitelisted(host)) {
    return DEFAULT_OP_CO
  }

  throw new PlatformError(`No whitelabel OpCo found that matches host: ${host}`)
}

export const getWhitelabelPlatformConfigForHost = (
  host?: string,
  overrides?: Partial<Omit<PlatformConfig, 'opCo'>>
): PlatformConfig => {
  const opCo = getWhitelabelOpCoForHost(host)
  const opCoMeta = getOpCoMetaConfig(opCo)
  const theme =
    !!host && isAviosThemeWhitelisted(host) ? 'avios' : overrides?.theme ?? opCoMeta.whitelabelTheme
  const locale = overrides?.locale ?? opCoMeta.defaultLocale
  const market = overrides?.market ?? opCoMeta.defaultMarket

  return { opCo, locale, market, theme }
}
